<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>个人中心</span></div>
			<div class="center flex-between">
				<centerLeft :menu="-8"></centerLeft>
				<div class="center-right">
					<div class="order">
						<div class="order-title">退货详情</div>
						<div class="ordergoods-table">
							<div class="ordergoods-table-title flex-center flex-between">
								<div class="ordergoods-table-title-title">商品信息</div>
								<div class="ordergoods-table-title-price">退货数量</div>
								<div class="ordergoods-table-title-price">退款金额</div>
							</div>
							<div class="ordergoods-table-body">
								<div class="ordergoods-table-item flex-between flex-center">
									<div class="ordergoods-table-item-goods flex-start flex-center">
										<img class="ordergoods-table-item-goods-image" :src="info.goodsSpecImage" mode="aspectFill"></img>
										<div class="ordergoods-table-item-goods-text">
											<div>{{info.goodsName}}</div>
											<div>{{info.goodsSpecName}}</div>
										</div>
										<div class="ordergoods-table-item-price">{{info.returnNum}}</div>
										<div class="ordergoods-table-item-value">￥{{info.returnPrice}}</div> 
									</div>
								</div>
							</div>
						</div>
						
						
						<div class="order-title">退货信息</div>
						<div class="address flex-between flex-center">
							<div class="address-info">
								
								<div style="cursor: pointer;" @click="toOrderInfo"><span>原订单编号：</span>{{info.orderNo}}</div>
								<div><span>退货原因：</span>{{info.returnReason}}</div>
								<div><span>问题描述：</span>{{info.problem}}</div>
								<div><span>退款金额：</span>￥{{info.returnPrice}}</div>
								<div v-if="info.status == 2"><span>实际退款金额：</span>{{info.actualReturnPrice}}</div>
								<div v-if="info.status == 2"><span>退积分数：</span>{{info.integralPrice?info.integralPrice:0}}</div>
								<div><span>售后编号：</span>{{info.returnNo}}</div>
								<div><span>申请时间：</span>{{info.createTime}}</div>
								<div v-if="info.status == -1"><span>售后状态：</span>已拒绝</div>
								<div v-if="info.status == 1"><span>售后状态：</span>待审核</div>
								<div v-if="info.status == 2"><span>售后状态：</span>已退款</div>
								<div v-if="info.remark"><span>审核备注：</span>{{info.remark}}</div>
							</div>
						</div>
						
						<div class="order-title">售后申请凭证</div>
						<div class="address flex-between flex-center">
							<div class="address-info">
								<div class="image-list flex-start flex-center flex-wrap">
									<div class="image-list-item" v-for="(item, index) in info.image_arr" :key="index">
										<img :src="item"/>
									</div>
								</div>
							</div>
						</div>
						
					</div>
				</div>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import centerLeft from '@/components/center-left.vue'
import {getReturnDetail} from "@/api/user"
export default {
	name: 'index',
	components:{
		centerLeft
	},
	data(){
		return {
			info:{},
			id:0,
			show:false
		}
	},
	mounted() {
			this.id = this.$route.query.id || 0;
			this.getInfo();
	},
	methods:{
		getInfo(){
			getReturnDetail({returnId:this.id}).then(res=>{
				if(res.code == 1000){
					this.info = res.data;
					this.info.image_arr = res.data.image?res.data.image.split(","):[];
					this.show = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		toOrderInfo(){
			this.$router.push("/orderinfo?id="+(this.info.orderId*23+20));
		}
	}
	
}
</script>

<style lang="scss" scoped>
	.image-list{
		.image-list-add{
			width: 106px;
			height: 106px;
			border: 1px dashed rgba(0, 0, 0, 0.4);
			padding: 30px 0px 30px;
			box-sizing: border-box;
			text-align: center;
			margin: 0px 16px 16px 0px;
			img{
				width: 24px;
				height: 24px;
			}
			div{
				font-size: 12px;
				line-height: 16px;
				color: #070B13;
				margin-top: 8px;
			}
		}
		.image-list-item{
			width: 108px;
			height: 108px;
			position: relative;
			margin: 0px 16px 16px 0px;
			img{
				width: 108px;
				height: 108px;
				object-fit: cover;
			}
			.icon-close{
				width: 16px;
				height: 16px;
				position: absolute;
				top: 0px;
				right: 0px;
			}
		}
	}
	.order-title{
		font-size: 16px;
		font-weight: 500;
		color: #070B13;
		line-height: 72px;
	}
	
	.address{
		border: 1px solid rgba(0, 0, 0, 0.1);
		box-sizing: border-box;
		padding: 20px 60px 20px 30px;
		.address-edit{
			flex: 0 0 100px;
			margin-right: 60px;
			img{
				width: 20px;
				height: 20px;
				flex: 0 0 20px;
				margin-right: 12px;
			}
			div{
				font-size: 16px;
				line-height: 20px;
				color: #070B13;
			}
		}
		.address-action{
			border-left: 1px solid rgba(0, 0, 0, 0.1);
			padding-left: 60px;
			div{
				width: 152px;
				height: 36px;
				border: 1px solid rgba(7, 11, 19, 0.3);
				font-size: 14px;
				color: #070B13;
				line-height: 36px;
				text-align: center;
				margin: 8px 0px;
				cursor: pointer;
				&:last-of-type{
					color: rgba(233, 26, 18, 1);
				}
			}
		}
		.address-info{
			width: 100%;
			div{
				font-size: 16px;
				line-height: 22px;
				color: #070B13;
				padding: 8px 0px;
				span{
					width: 120px;
					font-size: 16px;
					color: rgba(7, 11, 19, 0.6);
					display: inline-block;
				}
			}
		}
	}
	
	.order-success{
		text-align: center;
		padding-top: 160px;
		padding-bottom: 50px;
		img{
			width: 64px;
			height: 64px;
		}
		.order-success-title{
			font-size: 18px;
			line-height: 24px;
			color: #070B13;
			margin-top: 20px;
		}
		.order-success-desc{
			opacity: 0.6;
			font-size: 14px;
			line-height: 24px;
			text-align: center;
			color: #070B13;
			margin-top: 8px;
		}
		.order-success-button{
			width: 260px;
			height: 46px;
			border: 1px solid rgba(233, 26, 18, 0.1);
			font-size: 16px;
			font-weight: 500;
			line-height: 46px;
			text-align: center;
			color: #070B13;
			margin: 20px auto 0px;
			cursor: pointer;
		}
	}
	.bottom{
		margin-top:20px;
		.bottom-left{
			.bottom-left-title{
				img{
					width: 20px;
					height: 20px;
					margin-right: 8px;
				}
				div{
					opacity: 0.6;
					font-size: 16px;
					line-height: 24px;
					color: #070B13;
				}
			}
			.bottom-left-desc{
				opacity: 0.6;
				font-size: 16px;
				line-height: 24px;
				color: #070B13;
				margin-left: 28px;
			}
		}
		
		.order-result-item-button{
			width: 240px;
			height: 56px;
			background: #E91A12;
			font-size: 20px;
			font-weight: 500;
			letter-spacing: 0em;
			text-align: center;
			color: #FFFFFF;
		}
	}
	.image-title{
		font-size: 12px;
		line-height: 16px;
		color: #070B13;
		margin-left: 100px;
	}
	.image-desc{
		opacity: 0.4;
		font-size: 12px;
		line-height: 16px;
		color: #070B13;
		margin-left: 100px;
		margin-top: 8px;
	}
	.image-list{
		.image-list-add{
			width: 106px;
			height: 106px;
			border: 1px dashed rgba(0, 0, 0, 0.4);
			padding: 30px 0px 30px;
			box-sizing: border-box;
			text-align: center;
			margin: 0px 16px 16px 0px;
			img{
				width: 24px;
				height: 24px;
			}
			div{
				font-size: 12px;
				line-height: 16px;
				color: #070B13;
				margin-top: 8px;
			}
		}
		.image-list-item{
			width: 108px;
			height: 108px;
			position: relative;
			margin: 0px 16px 16px 0px;
			img{
				width: 108px;
				height: 108px;
				object-fit: cover;
			}
			.icon-close{
				width: 16px;
				height: 16px;
				position: absolute;
				top: 0px;
				right: 0px;
			}
		}
	}
	.refund-form{
		width: 100%;
		border: 1px solid rgba(7, 11, 19, 0.1);
		box-sizing: border-box;
		padding: 20px;
		.set-num{
			img{
				 width: 24px;
				 height: 24px;
				 flex: 0 0 24px;
			}
			div{
				font-size: 16px;
				font-weight: 500;
				line-height: 40px;
				color: #060707;
				margin: 0px 20px;
				&:last-of-type{
					color: rgba(7, 11, 19, 0.6);
				}
			}
		}
	}
	
	.ordergoods-table-body{
		padding: 0px;
		.ordergoods-table-item{
			padding-left: 40px;
			padding-right: 40px;
			box-sizing: border-box;
			font-size: 14px;
		}
	}
	.order{
		width: 100%;
		background: #FFFFFF;
		box-sizing: border-box;
		.order-title{
			font-size: 16px;
			font-weight: 500;
			color: #070B13;
			line-height: 72px;
		}
	}
	.center-right{
		min-height: 920px;
		width: 100%;
		padding:0px 40px 40px;
		box-sizing: border-box;
		border-left: 1px solid rgba(0, 0, 0, 0.1);
	}
	@import url("../assets/user.scss");
	@import url("../assets/order.scss");
</style>
